import { Tabs as LibTabs } from "@mui/material";

import styled from "styled-components";

export const Tabs = styled(LibTabs)`
  &.MuiTabs-root {
    min-height: fit-content;
    border-bottom: 1px solid #a48b7873;
    overflow: unset;

    & > div {
      overflow: unset !important;
    }
  }

  & button {
    width: 50%;
    max-width: 50%;
    color: #cbbaac;
    font-size: 0.75rem;
    padding: 10px 0;
    height: fit-content;
    min-height: fit-content;
  }

  && .Mui-selected {
    color: #f5dfc4;
  }

  && {
    .MuiTabs-indicator {
      height: 1px;
      background-color: #f5dfc4;
      transform: translateY(100%);
    }
  }
`;
